import {textStylesSelector} from "./textStyleSelector";
export const getImageLegendItems = (componentData) => {

    const {titleStyle} = textStylesSelector(componentData);

    const items = {};
    items.title = componentData?.fields?.title;
    items.titleStyle = {...titleStyle?.fields};
    items.mobileImageTitle = componentData?.fields?.elements?.[0]?.fields?.mobileImage?.fields?.title;
    items.mobileImageUrl = componentData?.fields?.elements?.[0]?.fields?.mobileImage?.fields?.file?.url;
    items.mobileImageDescription = componentData?.fields?.elements?.[0]?.fields?.mobileImage?.fields?.description;
    items.desktopImageTitle = componentData?.fields?.elements?.[0]?.fields?.desktopImage?.fields?.title;
    items.desktopImageUrl = componentData?.fields?.elements?.[0]?.fields?.desktopImage?.fields?.file?.url;
    items.desktopImageDescription = componentData?.fields?.elements?.[0]?.fields?.desktopImage?.fields?.description;
    items.legendItems = componentData?.fields?.elements?.[0]?.fields?.legendEntries?.map(entry => {return {url: entry?.fields?.icon?.fields?.file?.url, text: entry?.fields?.question};});
    items.bgColor = componentData?.fields?.backgroundColour;
    items.gridSpacing = componentData?.fields?.gridSpacing;
    items.gridColumns = componentData?.fields?.gridColumns;
    items.variant = componentData?.fields?.elements?.[0]?.fields?.legendPosition;
    return items;
};
